
import CookieDialog from '~/components/lazyloads/dialogs/CookieDialog.vue'

export default {
  name: 'Privacy',

  layout: 'layout-meta',

  components: {
    CookieDialog,
  },

  transition: 'myuse-fade',

  async asyncData({ $content }) {
    const page = await $content(
      'privacy/privacy-user'
    ).fetch()

    return {
      page,
    }
  },

  data: () => ({
    page: false,
    showBtn: false,
    enabled_ga: false,
    show_deletion_button: true,
  }),

  computed: {
    user() {
      return this.$store.getters.getUser
    },
  },

  mounted() {
    this.enabled_ga =
      this.$store.getters[
        'auth/getGACookieStatus'
      ]

    this.$nuxt.$on(
      'reloadCookieDisplay',
      this.reloadCookieDisplay
    )
  },

  beforeDestroy() {
    this.$nuxt.$off(
      'reloadCookieDisplay',
      this.reloadCookieDisplay
    )
  },

  methods: {
    async deleteGAData() {
      this.$dialog.message.error(
        'We are processing your request. Once deletion is requested, data associated with this user identifier will be removed from the Individual User Report within 72 hours, and then deleted from Analytics servers during the next deletion process within the next 63 days.',
        {
          position: 'top',
          color: 'green',
          timeout: 4000,
        }
      )

      this.$axios
        .$post(
          this.$config.BASE_API +
            '/activity/delete_ga_data',
          {
            user: this.user,
          }
        )
        .catch(() => {})

      this.show_deletion_button = false

      try {
        if (this.$ga) {
          await this.$ga.event(
            'Attempted to delete data',
            'Privacy page'
          )
        }
      } catch (_) {}
    },

    reloadCookieDisplay() {
      this.enabled_ga =
        this.$store.getters[
          'auth/getGACookieStatus'
        ]
    },

    getPos(id) {
      try {
        const ref =
          this.$refs[id]

        if (
          Array.isArray(ref) &&
          ref.length
        ) {
          return ref[0].offsetTop
        }

        if (ref) {
          return ref.offsetTop
        }

        return 0
      } catch (_) {
        return 0
      }
    },

    scrollTo(id) {
      try {
        window.scrollTo({
          top:
            this.getPos(id) -
            80,
          behavior: 'smooth',
        })
      } catch (_) {}
    },

    onScroll() {
      if (
        !this.page ||
        !Array.isArray(
          this.page.sections
        ) ||
        !this.page.sections.length
      ) {
        this.showBtn = false
        return
      }

      const topSection =
        this.page.sections[0].id

      this.showBtn =
        window.scrollY >
        this.getPos(topSection)
    },
  },
}
